import React, { FC, useState } from 'react';

import { startOfDayUTC } from '@go-shared/lib/time';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './NativeDatePicker.scss';
interface NativeDatePickerProps {
  label: string;
  initialDate?: Date;
  onDateChange: (newDate?: Date) => void;
  isClearable?: boolean;
}
export const NativeDatePicker: FC<NativeDatePickerProps> = ({
  initialDate,
  label,
  onDateChange,
  isClearable = false,
}) => {
  const [date, setDate] = useState<Date | undefined>(initialDate);

  const handleDateChange = (newDate: Date | null) => {
    let newDateUTC = newDate ? startOfDayUTC(newDate) : undefined;

    onDateChange(newDateUTC);
    setDate(newDateUTC);
  };

  return (
    <span className="inline-flex items-baseline">
      <span>
        <label className="text-small text-grey-darkest font-semibold mr-2">{label}</label>
      </span>
      <DatePicker
        placeholderText="Select a date"
        isClearable={isClearable}
        selected={date}
        onChange={handleDateChange}
      />
    </span>
  );
};
